//
//
//
//
//
//
//
//

import  InTitle  from '../title'
import Xfrom from '../from'
import { InsurStore,InsurMutations } from '../../store'
import { store } from '@/observable/store'

    export default {
        data() {
            return {
                defaultData:{}
            }
        },
        components: {
            InTitle,
            Xfrom
        },
        props: {
            dataList: {
                type: Array,
                default: ()=>{
                    return []
                },
            }
        },
        computed: {
        },
        created(){
            this.getinfo()
        },
        methods: {
            check() {
                return this.$refs.MyFrom.check()
            },
            info(){
                return this.$refs.MyFrom.info()
            },
            getinfo(){
                //本人信息默认展示上一次投保的信息
                this.defaultData =  InsurMutations.getmyInfo()
            }
        },
    }
